function init() {

    masonrySetup();
    setActive();

}

function masonrySetup() {
    var $container = $(".news-grid");
    if ($container && $container.masonry) {
        $container.masonry({
            itemSelector: ".news-block-wrapper",
            transitionDuration: 0
        });
    }
}

function setActive() {
    var curPage = window.location.href.split('?')[0];
    var pills = $("a.fil-btn-pill");
    let i = 0;
    while (i < pills.length) {
        var link = pills[i].href;
        if (curPage == link) {
            //add active class
            pills[i].classList.add('active');
        }
        i++;
    }
}

export default {
    init
}